"use strict";

var _SignIn = _interopRequireDefault(require("../components/sign_in/SignIn"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

$(function () {
  var el = $('.SignInMainBody');
  var signInView = new _SignIn["default"](el, window.OverDrive.loginForms, window.OverDrive.forwardUrl, window.OverDrive.formKey, window.OverDrive.errorMessage, window.OverDrive.captchaRequired, window.OverDrive.showIdcSignUp, window.OverDrive.previousUsername);

  signInView._render();
});